import * as Services from "../../Service/Service";
import * as Url from "../../Service/Url";

export const GetListOfClinicalTeamMemberDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_LIST_OF_CLINICAL_TEAM_MEMBER_DETAILS,
    token
  );
  return res;
};

export const CreateClinicalTeamMember = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_CLINICAL_TEAM_MEMBER, payload, token);
  return res;
};

export const UpdateClinicalTeamMember = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATECLINICALTEAMMEMBER, payload, token);
  return res;
};

export const DeleteClinicalTeamMember = async (email) => {
  const token = localStorage.getItem("token");
  const params = { email };
  let res = await Services.DELETE(
    Url.DELETECLINICALTEAMMEMBER + email,
    params,
    token
  );
  return res;
};
